import $ from 'jquery';
import '@fancyapps/fancybox';

$('[data-fancybox]').fancybox({
    backFocus: false,
});
